import { capitalize } from "@mui/material";
import { useTranslation } from 'react-i18next';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';
import './ExamPreview.css'
import ConfirmationModal from "../Modals/ConfirmationModal/ConfirmationModal";
import { useState } from "react";
import axios from "axios";
import LoadingOverlay from "../LoadingOverlay/LoadingOverlay";
import { sanitizeUrl } from '../../utils/functions';

/**
 * Renders an exam styled component.
 *
 * @param {Object} props
 * @param {Object} props.exam
*/
const ExamPreview = ({ exam, onDelete }) => {
    const { t } = useTranslation();
    const [showDeleteExamConfirmationModal, setShowDeleteExamConfirmationModal] = useState(false);
    const [loading, setLoading] = useState(false); 

    if (!exam) return null;

    const fileUrl = sanitizeUrl(process.env.REACT_APP_BACKEND_URL + exam.fileUrl);

    const isImage = exam.fileMimeType.startsWith("image/");
    const isPdf = exam.fileMimeType === "application/pdf";

    const deleteExam = async () => {
        setLoading(true);
        try {
            await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/exams/${exam._id}`, { withCredentials: true });
        } catch (error) {
            console.log(error);
        } finally {
            onDelete();
            setShowDeleteExamConfirmationModal(false);
            setLoading(false);
        }
    }

    return (
        <>
        <LoadingOverlay open={loading} />
        <div id="exam-preview-component" className="exam-preview">

            <div id="epc-type-wrapper">
                <h4 className="truncate">{capitalize(exam.examType)}</h4>

                <div id="epc-action-buttons">
                    {/* Download button */}
                    <div
                        id="epc-download-wrapper"
                        onClick={() => fileUrl && window.open(fileUrl, "_blank", "noopener,noreferrer")}
                    >
                        <DownloadIcon />
                        <p>{t("Download")}</p>
                    </div>

                    {/* Delete button */}
                    <div
                        id="epc-delete-wrapper"
                        onClick={() => setShowDeleteExamConfirmationModal(true)}
                    >
                        <DeleteIcon />
                        <p>{capitalize(t("delete"))}</p>
                    </div>
                </div>

            </div>

            <p>{capitalize(exam.description)}</p>

            <div>
                {/* Preview section */}
                {isImage && (
                    <img
                        src={fileUrl}
                        alt={exam.examType}
                        style={{ width: "100%", maxWidth: "400px", marginTop: "10px" }}
                    />
                )}

                {isPdf && (
                    <iframe
                        src={fileUrl}
                        title="PDF Preview"
                        width="100%"
                        height="500px"
                        style={{ border: "1px solid #ccc", marginTop: "10px" }}
                    ></iframe>
                )}

                {/* This case should never happen */}
                {!isImage && !isPdf && (
                    <p>{capitalize(t("errorMessages.preview-not-available"))}</p>
                )}

            </div>

            {/* Delete confirmation modal */}
            {showDeleteExamConfirmationModal && 
                <ConfirmationModal
                    id={"delete-exam-confirmation-modal"}
                    titleText={t("delete-exam") + ": " + capitalize(exam.examType)}
                    bodyText={t("confirm-delete-exam")}
                    handleConfirm={() => deleteExam()}
                    handleClose={() => setShowDeleteExamConfirmationModal(!showDeleteExamConfirmationModal)}

                />
            }
            
        </div>
        </>
    );
};

export default ExamPreview;